import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { StatClick } from '@app-model/businessCard';
import { RealEstateListing } from '@app-model/realEstate';
import { UtmService } from '@app-services/utm.service';

@Component({
	selector: 'app-listing-details-promoted-content',
	templateUrl: './listing-details-promoted-content.component.html',
	styleUrls: ['./listing-details-promoted-content.component.scss'],
	encapsulation: ViewEncapsulation.None
})
export class ListingDetailsPromotedContentComponent implements OnInit {
	@Input() listing: RealEstateListing;
	@Input() smallListing?: boolean;
	@Input() canonicalURL?: string;
	@Input() variant?: string = 'DEFAULT';

	@Output() clickHandler = new EventEmitter<StatClick>();

	countMetaItems = 0;

	isHorizontal = false;
	isPanoramic = false;

	constructor(public utms: UtmService) {}

	ngOnInit(): void {
		this.countMetaItems = this.listing?.sqft > 0 ? 1 : 0;
		this.countMetaItems += this.listing?.bedrooms > 0 ? 1 : 0;
		this.countMetaItems += this.listing?.bathrooms && this.listing?.bathrooms !== '0' ? 1 : 0;

		this.isHorizontal = this.variant === 'HORIZONTAL';
		this.isPanoramic = this.variant === 'PANORAMIC';
	}

	onClick(): void {
		const statsClick: StatClick = {
			linkUrl: this.getUrl()
		};

		this.clickHandler.emit(statsClick);
	}

	getUrl(): string {
		if (this.listing?.productOwnUrl && this.canonicalURL && this.canonicalURL.length > 0) {
			return this.canonicalURL + '/listing/' + this.listing.id;
		}
		return this.utms.addUtmToUrl(this.listing.url, this.canonicalURL);
	}
}
